import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DateRangeSelector from '../../../Components/DateRangeSelector/DateRangeSelector';

export class SessionsDateRangeSelector extends Component {
  static propTypes = {
    uniqueId: PropTypes.string.isRequired,
    isBig: PropTypes.bool.isRequired,
    mixpanelData: PropTypes.shape({
      action: PropTypes.string.isRequired,
      reportType: PropTypes.string
    }),
    reduced_sessions: PropTypes.object,
    getSessions: PropTypes.func
  };

  render() {
    const { uniqueId, isBig, reduced_sessions, getSessions, mixpanelData } = this.props;
    const { filter, fetching } = reduced_sessions;
    return (
      <DateRangeSelector
        uniqueId={uniqueId}
        isBig={isBig}
        onApply={(startDate, endDate) => {
          getSessions(startDate, endDate);
        }}
        fromDateTime={filter.fromTime}
        toDateTime={filter.toTime}
        disabled={fetching}
        mixpanelData={mixpanelData}
      />
    );
  }
}

export default SessionsDateRangeSelector;



// WEBPACK FOOTER //
// ./src/GoToWebinar/Sessions/Filters/SessionsDateRangeSelector.js